import { ActionTypes } from 'store/actions/successPage';

const defaultSessionState = {
    videoUrl: ''
};

function successPage (state = defaultSessionState, action) {
    switch (action.type) {
        case ActionTypes.SET_SUCCESS_PAGE_VIDEO_URL:
            return {
                ...action.session,
                videoUrl: action.payload
            };

        default:
            return state;
    }
}

export default successPage;



// WEBPACK FOOTER //
// ./src/js/store/reducers/successPage.js